import { useMutation } from '@tanstack/react-query';

const useHashChUserId = () => {
  return useMutation({
    mutationFn: async (userId: string) => {
      const response = await fetch(`/api/ch/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        return;
        // throw new Error('Network response was not ok');
      }

      const data = await response.json();
      return data;
    },

    mutationKey: ['hash-ch-user-id'],
  });
};

export default useHashChUserId;
